import React, { useState } from 'react'
import { useGlobal } from '../GlobalContext'
import MonitorsGroup from './MonitorsGroup'
import MonitorsGroupModal from './MonitorsGroupModal'

export default function MonitorsSideBar() {
  const defaultGroup = {
    name: 'Monitors Group 1',
    monitorsArr: [
      {
        id: 101,
        site: 'Footlocker US',
        product: 'Nike Dunk SB Royal Blue',
        host: 'Localhost',
        tasks: '17 Tasks',
        profile: 'Profile 1',
      },
      {
        id: 102,
        site: 'Footlocker US',
        product: 'Nike Dunk SB Royal Blue',
        host: 'Localhost',
        tasks: '17 Tasks',
        profile: 'Profile 1',
      },
      {
        id: 103,
        site: 'Footlocker US',
        product: 'Nike Dunk SB Royal Blue',
        host: 'Localhost',
        tasks: '17 Tasks',
        profile: 'Profile 1',
      },
    ],
  }
  const [modal, showModal] = useState(false)
  const { monitGroups, setMonitGroups, activeMonitGr, setActiveMonitGr } = useGlobal()
  const closeModal = (e) => {
    showModal(false)
  }
  const addGroup = (name) => {
    const newGroup = { ...defaultGroup, name, id: Date.now() }
    if (monitGroups.length < 1) {
      setActiveMonitGr(newGroup)
    }
    setMonitGroups((prev) => [...prev, newGroup])
  }
  return (
    <div className='flex flex-col pl-6 py-4  min-h-[550px] h-full bg-dg'>
      <div className='flex justify-between pr-6'>
        <span className='text-xs '>Monitors Groups</span>
        <span
          onClick={() => {
            showModal(true)
          }}
          className='text-[10px] add-plus-icon text-dblue cursor-pointer'>
          Add Group
        </span>
      </div>
      <div className='w-full flex-shrink-0 flex pr-6 '>
        <span className='h-0.5 w-full bg-dblack my-[11px]'></span>
      </div>
      <div className='h-[calc(100%-50px)] overflow-y-scroll scrl pr-6'>
        {monitGroups &&
          monitGroups?.length > 0 &&
          monitGroups.map((group, i) => (
            <MonitorsGroup
              key={group.id}
              monitGroup={group}
              idx={i}
              active={group.id === activeMonitGr.id}
              setActive={setActiveMonitGr}
            />
          ))}
      </div>
      {modal && (
        <div
          onClick={(e) => {
            if (e.target.classList[0] === 'cont') {
              closeModal()
            }
          }}
          className='cont z-10 fixed top-0 left-0 w-full h-full bg-black bg-opacity-40 flex justify-center items-center'>
          <MonitorsGroupModal closeModal={closeModal} addGroup={addGroup} />
        </div>
      )}
    </div>
  )
}
